import * as React from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {Redirect, Route, RouteChildrenProps, Switch} from 'react-router-dom';
// async components
import {AsyncRequestsListComponent} from '../components/AsyncComponent/AsyncComponent';
import {config} from "../config";

const Requests: React.FunctionComponent<RouteChildrenProps> = ({match}) => {
    const {t: translate} = useTranslation();
    return (
        <div className="content-wrapper">
            <Helmet>
                <title>{`${config.app.name} - ${translate('apiKeys.name')}`}</title>
                <meta name="description" content="Requests"/>
            </Helmet>
            <Switch>
                <Route exact path={`${match?.url}`} component={AsyncRequestsListComponent}/>
                <Redirect exact from={`${match?.url}/`} to={`${match?.url}`}/>
            </Switch>
        </div>
    );
};

export default Requests;
